/**
 * Returns a value for a key in iv parameter
 * https://goo.gl/XuKt8U
 *
 * @param {String} iv Any iv parameter
 * @param {String} key The key of the desired value
 * @return {Strig} The value of the key searched for
 */
function getIvKeyValue(iv, key) {
  const ivParams = iv.replace(/(__iv_|vi__)/g, '');
  let value = '';

  if (!key) return '';
  const m = ivParams.match(new RegExp(`(${key})_([^_]+)`));
  if (m) value = m[2];
  return value;
}

export default getIvKeyValue;
